import React from 'react';
import Button from '@alltrails/shared/denali/components/Button';

import { AlertDrawerActionTarget, AlertDrawerActionType, AlertDrawerOpenAction, setVisible } from '../../redux/slices/alertsDrawer/alertsDrawer';
import { useSelector, useDispatch } from '../../redux/hooks';
import { clearAllFilters } from '../../redux/slices/filters';

const AlertButton = (): JSX.Element => {
  const dispatch = useDispatch();
  const visible = useSelector(state => state.alertsDrawer.visible);
  const pending = useSelector(state => state.alertsDrawer.pending);
  let name;
  if (visible) {
    if (pending) {
      name = 'Cancel';
    } else {
      name = 'Close';
    }
  } else {
    name = 'Add alert';
  }
  const buttonProps = {
    text: name,
    testId: name,
    onClick: () => {
      const payload: AlertDrawerOpenAction = { visible: !visible };
      if (!visible) {
        payload.action = AlertDrawerActionType.ADD;
        payload.target = AlertDrawerActionTarget.AREAS;
      } else {
        dispatch(clearAllFilters());
      }
      dispatch(setVisible(payload));
    }
  };

  return <Button {...buttonProps} size="sm" variant={visible ? 'default' : 'primary'} />;
};

export default AlertButton;
